module.exports = __webpack_public_path__ + "static/media/note.76d4b8b4.svg";